import { useState } from 'react'
import { useCloseModal, useConfigureModalController, useModalController } from '@/atoms'

type ModalStatus = 'ready'

interface ModalData {
  trafficAreaIds: string[]
}

type ModalProps = {
  trafficAreas: string[]
}

export const modalId = 'deleteTrafficArea'
export const useController = () => useModalController<ModalData, ModalStatus>(modalId)

export const useConfigureController = ({ trafficAreas }: ModalProps) => {
  const close = useCloseModal()

  const [options] = useState(() => ({
    createInitialState: () => ({
      status: 'ready' as ModalStatus,
      data: { trafficAreaIds: trafficAreas },
      close,
    }),
  }))

  return useConfigureModalController<ModalData, ModalStatus>(modalId, options)
}
